export default __webpack_public_path__ + "static/media/info_yellow.17cb66a4.svg";